export default class PagedResponseService {
    /**
     * Maps a PagedResponse to a PagedResult.
     *
     * PagedResult is a subset of PagedResponse.  This method is intended to be used
     * by the Fetcher service to process PagedResponses received from the server.
     *
     * @param {PagedResponse<T>} pagedResponse -- the paged response
     * @throws {Error} when the paged response has success false
     * @returns {PagedResult<T>} paged result with the data from the paged response
     */
    static processPagedResponse(pagedResponse) {
        if (!pagedResponse.success) {
            if (console.error) {
                console.error(pagedResponse);
            }
            throw (pagedResponse.message ||
                "Invalid paged response: " + pagedResponse.toString());
        }
        return {
            data: pagedResponse.data,
            total: pagedResponse.total,
            offset: pagedResponse.offset,
            maxResults: pagedResponse.maxResults,
        };
    }
}
